// As telas de restaurante são independentes. Carregá-las sob demanda evita
// incluir toda a operação no bundle inicial de qualquer página do sistema.
const restauranteAmbientes = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Ambientes/Index"
  );
const restauranteAmbientesNovo = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Ambientes/Create"
  );
const restauranteAmbientesEditar = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Ambientes/Update"
  );
const restauranteMesas = () =>
  import(
    /* webpackChunkName: "restaurante-operacao" */ "@/modules/Restaurante/pages/Mesas/Operacional"
  );
const restauranteMesasCadastro = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Mesas/Index"
  );
const restauranteMesasNovo = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Mesas/Create"
  );
const restauranteMesasEditar = () =>
  import(
    /* webpackChunkName: "restaurante-cadastros" */ "@/modules/Restaurante/pages/Mesas/Update"
  );
const restauranteProducao = () =>
  import(
    /* webpackChunkName: "restaurante-producao" */ "@/modules/Restaurante/pages/Producao/Index.vue"
  );
const restauranteBar = () =>
  import(
    /* webpackChunkName: "restaurante-producao" */ "@/modules/Restaurante/pages/Bar/Index.vue"
  );
const restauranteCheckout = () =>
  import(
    /* webpackChunkName: "restaurante-checkout" */ "@/modules/Restaurante/pages/Checkout/Index.vue"
  );
const restaurantePedidoOnlineCheckout = () =>
  import(
    /* webpackChunkName: "restaurante-pedidos-online-checkout" */ "@/modules/Restaurante/pages/PedidosOnline/PedidoOnlineCheckout.vue"
  );
const restauranteCardapioOnline = () =>
  import(
    /* webpackChunkName: "restaurante-cardapio-online" */ "@/modules/Restaurante/pages/CardapioOnline/Index.vue"
  );
const restaurantePedidosOnline = () =>
  import(
    /* webpackChunkName: "restaurante-pedidos-online" */ "@/modules/Restaurante/pages/PedidosOnline/Index.vue"
  );
export default [
  {
    name: "restauranteAmbientes",
    path: "/restauranteAmbientes",
    component: restauranteAmbientes,
    meta: {
      title: "Restaurante - Ambientes",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteAmbientesNovo",
    path: "/restauranteAmbientes/novo",
    component: restauranteAmbientesNovo,
    meta: {
      title: "Restaurante - Ambientes",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteAmbientesEditar",
    path: "/restauranteAmbientes/:id/editar",
    component: restauranteAmbientesEditar,
    meta: {
      title: "Restaurante - Ambientes",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteMesas",
    path: "/restauranteMesas",
    component: restauranteMesas,
    props: {
      perfilOperacional: "caixa",
      titulo: "Salão Restaurante",
      subtitulo: "Mesa, comanda, produção e fechamento em uma operação só",
      exibirCheckout: true,
    },
    meta: { title: "Restaurante - Mesas", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteGarcom",
    path: "/restauranteGarcom",
    component: restauranteMesas,
    props: {
      perfilOperacional: "garcom",
      titulo: "Garçom",
      subtitulo: "Mesas, comandas e envio de pedidos para produção",
      exibirCheckout: false,
    },
    meta: { title: "Restaurante - Garçom", permission: "restauranteGarcom" },
  },
  {
    name: "restauranteCaixa",
    path: "/restauranteCaixa",
    component: restauranteMesas,
    props: {
      perfilOperacional: "caixa",
      titulo: "Caixa Restaurante",
      subtitulo: "Mesas, comandas, produção e fechamento de conta",
      exibirCheckout: true,
    },
    meta: { title: "Restaurante - Caixa", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteMesasCadastro",
    path: "/restauranteMesas/cadastro",
    component: restauranteMesasCadastro,
    meta: {
      title: "Restaurante - Cadastro de Mesas",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteAmbientesMesas",
    path: "/restauranteAmbientes/:ambienteId/mesas",
    component: restauranteMesasCadastro,
    meta: {
      title: "Restaurante - Mesas do Ambiente",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteMesasNovo",
    path: "/restauranteMesas/novo",
    component: restauranteMesasNovo,
    meta: { title: "Restaurante - Mesas", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesMesasNovo",
    path: "/restauranteAmbientes/:ambienteId/mesas/novo",
    component: restauranteMesasNovo,
    meta: {
      title: "Restaurante - Mesas do Ambiente",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteMesasEditar",
    path: "/restauranteMesas/:id/editar",
    component: restauranteMesasEditar,
    meta: { title: "Restaurante - Mesas", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesMesasEditar",
    path: "/restauranteAmbientes/:ambienteId/mesas/:id/editar",
    component: restauranteMesasEditar,
    meta: {
      title: "Restaurante - Mesas do Ambiente",
      permission: "restauranteAmbientes",
    },
  },
  {
    name: "restauranteProducao",
    path: "/restauranteProducao",
    component: restauranteProducao,
    meta: { title: "Restaurante - Produção", permission: "restauranteCozinha" },
  },
  {
    name: "restauranteBar",
    path: "/restauranteBar",
    component: restauranteBar,
    meta: { title: "Restaurante - Bar", permission: "restauranteBar" },
  },
  {
    name: "restauranteCozinha",
    path: "/restauranteCozinha",
    component: restauranteProducao,
    props: {
      tipoProducao: "cozinha",
      titulo: "Cozinha",
      subtitulo: "Pedidos enviados para produção da cozinha",
      exibirMesasAtalho: false,
    },
    meta: { title: "Restaurante - Cozinha", permission: "restauranteCozinha" },
  },
  {
    name: "restauranteCardapioOnline",
    path: "/restauranteCardapioOnline",
    component: restauranteCardapioOnline,
    meta: {
      title: "Restaurante - Cardápio Digital",
      permission: "restauranteCardapioOnline",
    },
  },
  {
    name: "restaurantePedidosOnline",
    path: "/restaurantePedidosOnline",
    component: restaurantePedidosOnline,
    meta: {
      title: "Restaurante - Pedidos Online",
      permissions: ["restaurantePedidosOnline", "restauranteEntregasOnline"],
    },
  },
  {
    name: "restauranteEntregasOnline",
    path: "/restauranteEntregasOnline",
    redirect: (to) => ({
      name: "restaurantePedidosOnline",
      query: {
        ...to.query,
        view: to.query.return_view || "operation",
        lane: "entrega",
        pedido: to.query.pedido_online_id || to.query.return_pedido,
      },
    }),
    meta: {
      title: "Restaurante - Pedidos Online / Entrega",
      permission: "restauranteEntregasOnline",
    },
  },
  {
    name: "restaurantePedidoOnlineCheckout",
    path: "/restaurante/pedidos-online/:pedidoOnlineId/checkout/:atendimentoId",
    component: restaurantePedidoOnlineCheckout,
    meta: {
      title: "Restaurante - Receber pedido online",
      permission: "restauranteCaixa",
    },
  },
  {
    name: "restauranteCaixaCheckout",
    path: "/restauranteCaixa/checkout/:atendimentoId",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteCaixaCheckoutComanda",
    path: "/restauranteCaixa/checkout-comanda/:codigoComanda?",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteMesasCheckout",
    path: "/restaurante/checkout/:atendimentoId",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
];
